import React from "react";
import { Box } from "@mantine/core";

const IssueTableInfoPanel = () => {
  return (
    <Box p="xs">
      <Box component="h4" mb="1rem">
        Tabelloversikt
      </Box>
      <h5>Justerbare kolonner:</h5>
      <p>
        Klikk pÃ¥ en kolonneoverskriftsdeler for Ã¥ endre stÃ¸rrelsen pÃ¥ en kolonne. Dobbeltklikk for automatisk
        stÃ¸rrelse. HÃ¸yreklikk for Ã¥ tilbakestille.
      </p>

      <h5>Omorganiser kolonner:</h5>
      <p>Klikk og dra en kolonneoverskrift for Ã¥ omorganisere tabellen.</p>

      <h5>KolonneverktÃ¸ylinje:</h5>
      <p>
        PÃ¥ venstre side er det en meny med kolonneoversikt. Her kan du slÃ¥ av og pÃ¥ enkeltkolonner eller grupper. Dra
        i listen for Ã¥ omorganisere. <br /> Disse endringene vil kun pÃ¥virke din nÃ¥vÃ¦rende visning og vil ikke bli
        lagret.
      </p>

      <h5>Kolonnegruppering:</h5>
      <p>
        Kolonner har blitt gruppert med etiketter for enklere organisering. Tilpassede attributtkolonner vil automatisk
        bli gruppert etter seksjon.
      </p>

      <h5>Celleinteraksjon:</h5>
      <p>
        Dobbeltklikk pÃ¥ en celle for Ã¥ redigere innholdet. HÃ¸yreklikk for Ã¥ kopiere til utklippstavlen.
        <br /> Hvis teksten er for lang for en kolonne, klikk pÃ¥ pilen ned i hÃ¸yre hjÃ¸rne av cellen for Ã¥ utvide.
        For Ã¥ utvide alle kolonner, klikk pÃ¥ den blÃ¥ knappen ved siden av fanene for tabellvisning.
      </p>
    </Box>
  );
};

export default IssueTableInfoPanel;
